import { inject } from 'vue';
import { BreakpointsRefState } from '@monolith/legacy/modules/design-system-candidates/breakpoints/types';
import { BREAKPOINTS_PROVIDE_ID } from '@monolith/legacy/modules/design-system-candidates/breakpoints/constants';

export default function useBreakpoints() {
  return inject<BreakpointsRefState>(BREAKPOINTS_PROVIDE_ID);
}
